import React, { memo, useCallback, useEffect } from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import FormItemsContainer from "../../../containers/FormItemsContainer";
import { AreaSearcher } from "../../pc/AreaForm";
import { areaParamsTranslate, areaOrStr, areaTextEndKeyword } from '../../../../utils/search';
import { MainSearcher, SubSeacher } from './Form'

const SearchModal = memo(({
  searchDeps,
  closeModal,
  search
  }) => {
  const { mainSearchItems, subSearchItems, items } = FormItemsContainer.useContainer();
  const statusItem = subSearchItems.filter(cat => cat.name === 'status')[0];
  const { aggsTotal, areaIds, volOrJob, areaKeywords, requestParam, setAreaKeywords, setDetailSearch } = ArticleSearchContainer.useContainer();
  const fetchSearch = useCallback(() => {
    closeModal();
    setDetailSearch(false)
    search();
  }, [...searchDeps]);

  var domestic_or_abroad_areas= []
  Object.keys(items.areas).map((key)=>{
    domestic_or_abroad_areas.push(...items.areas[key].regions)
  });
  const wholeAreas = [...domestic_or_abroad_areas,  ...items.extended_areas[volOrJob]["opts"]];
  const compleAreaState = (areaIds) => {
    let newAreaKeywords = areaParamsTranslate(areaIds, wholeAreas).areaKeywords;
    if (areaKeywords.split(areaOrStr)[0].includes(areaTextEndKeyword)) { // チェックボックスによるエリアテキストの上書き判定
      newAreaKeywords = [areaKeywords.split(areaTextEndKeyword)[0] + areaTextEndKeyword, ...newAreaKeywords].filter(w => w);
    }
    setAreaKeywords(newAreaKeywords.join(areaOrStr)); // 文字列
    requestParam["area_keywords"] = newAreaKeywords.join(areaOrStr)
  };

  useEffect(() => {
    compleAreaState(areaIds);
  }, [areaIds]);


  return (
    <div className="m_pcSearchModal">
      <div className='l_wideContent isWhite'>
        <h4 className='p_boxHeading'>条件を指定して探す<span className='resultGuide isRight'>該当ボランティア<span className='jsResultNum resultNum'>{aggsTotal}</span>件</span>
        </h4>
        <div className='m_infoTable'>
            <div className="areaList"><AreaSearcher/></div>
            <MainSearcher key={statusItem.title} {...statusItem}/>
            {mainSearchItems.map((cat) => {
              return <MainSearcher key={cat.title} {...cat}/>
            })}
            {subSearchItems.map((cat) => {
              return <SubSeacher key={cat.title} {...{...cat, ...{notAccordion: true}}}/>
            })}
        </div>
        <div className='modalBtn'>
          <button className='p_btn isLarge isMain jsModalSearch' onClick={fetchSearch}>
            検索する
          </button>
        </div>
      </div>
    </div>
  );
});

export default SearchModal;